import { render, staticRenderFns } from "./TabDetailSingleProperty.vue?vue&type=template&id=ba029894&scoped=true"
import script from "./TabDetailSingleProperty.vue?vue&type=script&lang=js"
export * from "./TabDetailSingleProperty.vue?vue&type=script&lang=js"
import style0 from "./TabDetailSingleProperty.vue?vue&type=style&index=0&id=ba029894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba029894",
  null
  
)

export default component.exports